import React, { useEffect, useState } from "react";
import "../styles/SlideShow.scss";

const BackgroundSlideshow = ({ images = [], interval = 5000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, interval);
    return () => clearInterval(timer);
  }, [images.length, interval]);

  return (
    <div className="slideshow-container animated2">
      {images.map((url, index) => (
        <div
          key={index}
          className={`slideshow-image ${
            index === currentIndex ? "active" : ""
          }`}
          style={{ backgroundImage: `url(${url})` }}
        />
      ))}
    </div>
  );
};

export default BackgroundSlideshow;
